import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
import { CourseHService } from '../courseH.service';
@Component({
  selector: 'submoduleH',
  templateUrl: 'submoduleH.component.html',
  styleUrls: ['submoduleH.component.scss']
})

export class AddsubmoduleHComponent implements OnInit {
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none"
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info:boolean=false;
  public isList:boolean=true;

  public HigherEdchildcourse: any;
  public HigherEdchildsemester: any;
  public selectedCourse: string = '';
  public selectedSemester: string = '';
  public HigherEdchildmodule: any;
  public selectedmodule: string = '';
  public HigherEdchildSubmodule: any;
  public selectedSubmodule: string = '';
/*------------------------------------------------------------*/
  public selectedmodulePost: string = '';
  public SubSubjectName: string = '';
  public HigherEdchildexam: any;
  public selectedexam: string = "";
/*------------------------------------------------------------*/


  subSubjectNames:any[] = [];
  public ShowSubSubjectSecData: any = [];


  constructor( private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
    private courseService: CourseHService) {
    this.schoolId = this.localStorage.retrieve('schoolid');
    
  }

  ngOnInit() {
    this.GetCourseList();
    this.ShowCourseSubmoduleMapping();
   
  
  }

  private GetCourseList(){
    this.courseService.getHigherEdChildCourseList().finally(() => { }).subscribe(
      response => {
        this.HigherEdchildcourse = response['items'];
        try {
          this.selectedCourse =  this.HigherEdchildcourse[0].CourseId;
          this.GetSemesterList()
        } catch (error) {
          
        }
        console.log('HigherEdchildcourse',this.HigherEdchildcourse)
      },
      error => {
        console.error(error);
      });
  };

  changecourse(selectedCourse) {
    console.log("courseT",selectedCourse)
    this.GetSemesterList()
   };

//--------------------------------------------------------------------------------------------

  private GetSemesterList(){
    this.courseService.getHigherEdChildSemesterList(this.selectedCourse).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildsemester = response;
        try {
          this.selectedSemester =  this.HigherEdchildsemester[0].Id;
          this.GetexamList();
        } catch (error) {
          
        }
        console.log('HigherEdchildSemester',this.HigherEdchildsemester)
      },
      error => {
        console.error(error);
      });
  };

  changesemester(selectedSemester) {
    console.log("semesterT",selectedSemester)
   };

/*---------------------------------------------------------------------------------------------------------------*/
private GetexamList(){
  this.courseService.getHigherEdChildExamList(this.selectedCourse,this.selectedSemester).finally(() => { }).subscribe(
    response => {
      this.HigherEdchildexam = response['Value'];
      try {
        this.selectedexam =  this.HigherEdchildexam[0].examid;
        this.GetModuleList();
      } catch (error) {
        
      }
      console.log('HigherEdchildexam',this.HigherEdchildexam)
    },
    error => {
      console.error(error);
    });
};

changeexam() {
  console.log("changeexam", this.selectedexam);

}
//--------------------------------------------------------------------------------------------

  private GetModuleList(){
    this.courseService.getHigherEdChildSubjectList(this.selectedCourse,this.selectedSemester,this.selectedexam).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildmodule = response['Value'];
        try {
          this.selectedmodule =  this.HigherEdchildmodule[0].SubjectId;
          this.GetSubModuleList()
        } catch (error) {
          
        }
        console.log('HigherEdchildmodule',this.HigherEdchildmodule)
      },
      error => {
        console.error(error);
      });
  };


   changedmodule(selectedmodule) {
    console.log("module",selectedmodule)
    this.GetSubModuleList();
   };
//--------------------------------------------------------------------------------------------


   private GetSubModuleList(){
    this.courseService.getHigherEdChildSubSubjectList(this.selectedCourse,this.selectedSemester,this.selectedmodule).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildSubmodule = response['Value'];
        console.log('HigherEdchildSubmodule',this.HigherEdchildSubmodule)
      },
      error => {
        console.error(error);
      });
  };


   changedSubmodule(selectedSubmodule) {
    console.log("submodule",selectedSubmodule)
   };
//--------------------------------------------------------------------------------------------

  private ShowCourseSubmoduleMapping() {
     this.courseService.ShowCourseSubmoduleMapping()._finally(() => { }).subscribe(response => {
         console.log("ShowCourseSubmoduleMapping",response);
         this.ShowSubSubjectSecData = response['Value'];
         this.subSubjectNames = response['Value'];
         console.log('subSubjectNames', this.subSubjectNames)
         console.log('ShowSubSubjectSecData', this.ShowSubSubjectSecData)

       }
     )
  }
//--------------------------------------------------------------------------------------------

postsubsubjectModeules() {
  var payload = {
    SubjectId: this.selectedmodulePost,
    SubSubjectName: this.SubSubjectName,
  };

  console.log("postbatchModeules",payload);

  this.courseService
    .postHigherHiEduSubSubjectsList(payload)
    .finally(() => {})
    .subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: "Sub Module Added Successfully",
        });
        this.display = "none";
        this.ShowCourseSubmoduleMapping();
        this.GetSubModuleList()

        console.log(response);
      },
      (error) => {}
    );
}

/*-------------------------------------------------------------------------------------------------------------------------*/

  roleinfo(){
    this.info=true;
   }
 
 
 editsubmodule(sem){
  
       this.display = "block";
    
 }
 
 
 addsubmodule() {
   this.display= "block"
   // this.display = true;
 }
 onCloseHandled() {
   this.display= "none";
 }
 
 
 

}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/submodule/submoduleH.component.ts